import React, { useState } from 'react';
import { Layout, Avatar, Dropdown, Row } from 'antd';
import styled from 'styled-components';
import { UserOutlined } from '@ant-design/icons';
import { COLORS } from '../../utils/constants';
import SignOut from '../../pages/Signout';

const { Header } = Layout;

const Navbar: React.FC = () => {
  const [signOutVisible, setSignOutVisible] = useState<boolean>(false);
  const menuItems = [
    {
      key: 'logout',
      label: 'Logout',
    },
  ];

  const handleClick = ({ key }: { key: string }) => {
    if (key === 'logout') {
      setSignOutVisible(true);
    }
  };

  return (
    <StyledHeader>
      <StyledProfileRow>
        <Dropdown
          menu={{
            items: menuItems,
            onClick: ({ key }) => {
              handleClick({ key });
            },
          }}
          placement="bottomRight"
        >
          <StyledAvatar size="large" icon={<UserOutlined />} />
        </Dropdown>
      </StyledProfileRow>
      <SignOut open={signOutVisible} setOpen={setSignOutVisible} />
    </StyledHeader>
  );
};

const StyledHeader = styled(Header)`
  background: ${COLORS.grey.secondaryLight};
  padding: 0;
  position: fixed;
  top: 0;
  right: 0;
  width: calc(100% - 256px);
  z-index: 1;
  height: 72px;
`;

const StyledProfileRow = styled(Row)`
  float: right;
  padding: 0 24px;
  cursor: pointer;
`;

const StyledAvatar = styled(Avatar)`
  margin: 12px 0;
`;

export default Navbar;
